// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".resizable-creator[data-v-10f828fd]{z-index:10000}", ""]);
// Exports
module.exports = exports;
